<template>
  <div style="padding-left: 1.75rem;">
    <div class="col2_head">
      <span><router-link :to="'/'" class="breadcrumb_home">Acasă /</router-link> {{ $route.name }}<div class="subHeadTitle">{{ $route.name }}</div></span>
      <div class="right" style="margin-top: 1.2rem;">
        <div v-if="PERMISIONS.create" class="right">
          <div @click="addItem" class="Button1">
            <div class="icon">
              <img @load="imgLoaded" src="../assets/media/for_table/circle_ADD_new_etap.svg" alt="">
            </div>
            <span class="Btn_content">
              Adaugă tip de procedură
            </span>
          </div>
        </div>
      </div>
    </div>
    <template v-if="PERMISIONS.list">
      <table-parent
        :reloadCount="reloadTable"
        :tableHead="tableHead"
        :prepareFn="prepareData"
        :apiModule="tableModule"
        :apiModuleName="'PROCEDURE_TYPE_PAGINATED'"
        :tableMinimizeHead="true"
        :tableSpread="true"
        @Btn2="editItem"
        @Btn3="deleteItem"
        @totalRecords="x => (totalRecords = x)"
      />
    </template>
    <template v-else>
      <h3 style="display: flex; flex-direction: column; align-items: center;">
        <span style="font-size: 4rem;">
          <i class="fas fa-exclamation-triangle"></i>
        </span>
        Acces interzis
      </h3>
    </template>
  </div>
</template>

<script>
  import PermisionsMixin from '@/mixins/procedureTypePermMixin.js'
  import { PROCEDURE_TYPE_PAGINATED, PROCEDURE_TYPE_ADD, PROCEDURE_TYPE_MODIFY, PROCEDURE_TYPE_DELETE } from '../api.js'
  import TableParent from '@/components/TableParent'
  import DialogModal from '@/components/DialogModal'

  export default {
    $Title() {
      return `ConectX - ${this.$route.name}`
    },
    inject: ['procedureType'],
    mixins: [PermisionsMixin],
    components: {
      TableParent
    },
    data() {
      return {
        reloadTable: 0,
        tableHead: [
          {title:'Denumire tip de procedură',sort:true,
          queryKey: 'name',
          bottomHead: {
              quikFiltre: true
          }},
          {title:'Descriere tip de procedură',
          queryKey: 'description',
          bottomHead: {
              quikFiltre: true
          }}
        ],
        tableModule: PROCEDURE_TYPE_PAGINATED,
        totalRecords: 0,
      }
    },
    watch: {
      procedureType: {
        handler() {
          this.reloadPage()
        },
        deep: true
      }
    },
    methods: {
      reloadPage() {
        this.reloadTable++
        this.totalRecords = 0
      },
      deleteItem(item) {
        if(!Number.isInteger(item?.id)) {
          this.$toastr.e('Anunțați administratorul.')
          return
        }

        this.$modal.show(
          DialogModal,
          {
            target: 'DeleteProcedure',
            title: 'Ștergere tip de procedură',
            content: '<span style="color:#f44336;display: block;margin-top: 2rem;"><i class="fas fa-exclamation-circle" style="font-size: 6rem;"></i> <p style="font-weight: 500;font-size: 2.2rem;">Ești sigur că vrei să ștergi tipul de procedură selectat?</p></span>',
            closeBtnText: 'Anulează',
            button: {
              type: 3,
              value: 'Șterge',
              handler: () => {
                const err = msg => this.$toastr.e(msg || 'Ștergerea tipului de procedură a eșuat.')

                this.setSafeLoad()
                PROCEDURE_TYPE_DELETE(item.id).then(res => {
                  if(this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
                    this.$toastr.s('Tipul de procedură a fost ștears cu succes.')
                  } else {
                    err()
                  }
                  this.setLoad()
                  this.reloadPage()
                }).catch(msg => {
                  err(msg)
                  this.setLoad()
                  this.reloadPage()
                })
              }
            }
          },
          {
            name: 'DeleteProcedure',
            adaptive: true,
            width: '650',
            height: '400'
          }
        )
      },
      editItem(item) {
        if(!Number.isInteger(item?.id)) {
          this.$toastr.e('Anunțați administratorul.')
          return
        }

        this.$modal.show(
          DialogModal,
          {
            target: 'EditProcedure',
            title: 'Modifică tip de procedură',
            inputs: [
              {
                id: 'name',
                label: 'Denumire tip procedură',
                errReason: 'Introduceți denumirea tipului de procedură.',
              },
              {
                id: 'description',
                label: 'Descriere tip procedură',
                errReason: 'Introduceți descrierea tipului de procedură.',
              },
            ],
            closeBtnText: 'Anulează',
            initialInputsData: item,
            button: {
              type: 2,
              value: 'Modifică',
              handler: sendData => {
                sendData = this.getEdited(sendData, item, true)
                
                const error = msg => {
                  this.$toastr.e(msg || 'Modificarea tipului de procedură a eșuat.')
                  this.reloadPage()
                  this.setLoad()
                }

                this.setSafeLoad(12000)
                PROCEDURE_TYPE_MODIFY(item.id, sendData)
                  .then(res => {
                    if (this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
                      this.$toastr.s('Tipul de procedură a fost modificată.')
                      this.reloadPage()
                      this.setLoad()
                    } else {
                      error()
                    }
                  })
                  .catch(error)
              },
            },
          },
          {
            name: 'EditProcedure',
            adaptive: true,
            width: '650',
            height: '800',
          }
        )
      },
      addItem() {
        this.$modal.show(
          DialogModal,
          {
            target: 'AddProcedure',
            title: 'Adaugă tip procedură',
            inputs: [
              {
                id: 'name',
                label: 'Denumire tip procedură',
                errReason: 'Introduceți denumirea tipului de procedură.',
              },
              {
                id: 'description',
                label: 'Descriere tip procedură',
                errReason: 'Introduceți descrierea tipului de procedură.',
              },
            ],
            closeBtnText: 'Anulează',
            button: {
              type: 2,
              value: 'Adaugă',
              handler: sendData => {
                const error = msg => {
                  this.$toastr.e(msg || 'Adăugarea tipului de procedură a eșuat.')
                  this.reloadPage()
                  this.setLoad()
                }

                this.setSafeLoad(12000)
                PROCEDURE_TYPE_ADD(sendData)
                  .then(res => {
                    if (this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
                      this.$toastr.s('Tipul de procedură a fost adăugat.')
                      this.reloadPage()
                      this.setLoad()
                    } else {
                      error()
                    }
                  })
                  .catch(error)
              },
            },
          },
          {
            name: 'AddProcedure',
            adaptive: true,
            width: '650',
            height: '800',
          }
        )
      },
      prepareData(row) {
        const spacer = window.innerWidth > 900
        
        const preparation = [row.name || '-', row.description || '-']

        if(spacer) {
          preparation.push({spacer:true})
        }

        const x = this.PERMISIONS
        const prepareBtn = []

        const uuid = row.createdByUser
        const checkOwner = o => {
          if(!o) return false
          if(o === true) return true
          if(o == uuid) {
            return true
          }
          if(Array.isArray(o) && o[1] == uuid) {
            return true
          }
          return false
        }

        if(checkOwner(x.edit)) {
          prepareBtn.push(2)
        }
        if(checkOwner(x.delete)) {
          prepareBtn.push(3)
        }
        if(prepareBtn.length) {
          preparation.push([prepareBtn])
        }

        return preparation
      }
    },
    async created() {
      if(!this.PERMISIONS.list) {
        return
      }
      if(window.innerWidth > 900) {
        this.tableHead.push({spacer:true})
      }
      if(this.checkParamsInObj(this.PERMISIONS, ['edit', 'delete'])) {
        this.tableHead.push({spacer:true,minimize:1,fixed:{
          right: true
        },bottomHead: {
            quikFiltre: 'clear'
        }})
      }
    }
  }
</script>

<style scoped>
  .Button1 img {
    opacity: 0;
    transition: opacity 200ms;
    transition-delay: 100ms;
  }
  @media only screen and (max-width: 500px) {
    .right {
      padding-right: 0 !important;
    }
  }
</style>